<template>
  <div id="app">
    <div class="app-body">
      <!-- 左侧导航栏 (仅桌面端显示，且不在联系我们页面显示) -->
      <el-aside v-if="!isMobile && $route && $route.name && !$route.name.includes('ToolDetail') && $route.name !== 'AboutPage'" width="250px" class="app-sidebar">
        <div class="logo-container">
          <img class="logo" src="@/assets/ailogo.png" alt="AI工具集 Logo" />
          <div class="title">工具箱</div>
        </div>
        <el-menu class="menu" mode="vertical" :default-active="activeMenu">
          <el-menu-item index="1" @click="goToHomePage" class="menu-item">
            <font-awesome-icon icon="home" class="menu-icon" />
            <span>首页</span>
          </el-menu-item>

          <!-- 动态分类选项 -->
          <el-menu-item
            v-for="(category, index) in categories"
            :key="category"
            :index="`category-${index}`"
            @click="scrollToCategory(category)"
            class="menu-item"
          >
            <font-awesome-icon :icon="getCategoryIcon(category)" class="menu-icon" />
            <span>{{ category }}</span>
          </el-menu-item>

          <el-menu-item index="about" @click="goToAboutPage" class="menu-item">
            <font-awesome-icon icon="phone" class="menu-icon" />
            <span>联系我们</span>
          </el-menu-item>
          <el-menu-item index="tech-docs" @click="goToTechDocs" class="menu-item">
            <font-awesome-icon icon="file-alt" class="menu-icon" />
            <span>技术文档</span>
          </el-menu-item>
        </el-menu>
      </el-aside>

     <!-- 移动端顶部区域 -->
<div v-if="isMobile && $route && $route.name && !$route.name.includes('ToolDetail')" class="header">
  <div class="header-logo-container">
    <img class="header-logo" src="@/assets/logo2.png" style="width: 120px;" alt="AI工具集 Logo" />
    <div class="mobile-header-description">
      【为您提供最前沿的AI工具，帮助您在AI时代抓住机遇、创造价值】
    </div>
    
    <div class="button-group">
      <button class="contact-us-button" @click="goToAboutPage">联系我们</button>
      <button class="contact-us-button" @click="goToTechDocs">技术文档</button>
    </div>
  </div>

  <!-- 分类折叠按钮 -->
  <button class="category-toggle-button" @click="toggleCategories">
    <font-awesome-icon :icon="isCategoriesExpanded ? 'chevron-up' : 'chevron-down'" />
    <span>分类选择</span>
  </button>

  <!-- 动态分类列表（折叠面板） -->
  <div v-show="isCategoriesExpanded" class="category-panel">
    <div
      v-for="(category, index) in categories"
      :key="index"
      class="category-item"
      @click="handleCategoryClick(category)"
    >
      <font-awesome-icon :icon="getCategoryIcon(category)" class="menu-icon" />
      <span>{{ category }}</span>
    </div>
  </div>
</div>

      <!-- 右侧内容区域 -->
<el-main class="app-main">
  <!-- 电脑端显示的顶部 logo -->
  <div v-if="!isMobile && $route && $route.name && !$route.name.includes('ToolDetail')" class="desktop-header">
    <img class="desktop-header-logo" src="@/assets/logo2.png" alt="AI工具集 Logo" />
    <div class="desktop-header-description">
      为您提供最前沿的AI工具，帮助您在AI时代抓住机遇、创造价值。
    </div>
  </div>
  <!-- 渲染页面内容 -->
  <router-view :isMobile="isMobile" :key="$route.fullPath" :selected-category="selectedCategory" />
</el-main>
    </div>
    <!-- 一键回到顶部按钮 -->
    <button v-if="isMobile" class="back-to-top" @click="scrollToTop">⬆️</button>
  </div>
</template>

<script>
import { ElAside, ElMenu, ElMenuItem, ElMain } from 'element-plus';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faLanguage, faUserAlt,faUsers, faLayerGroup, faBalanceScale, faProjectDiagram, faPencilAlt, faBook, faImage, faRobot, faChartLine, faUserGraduate, faMusic, faPlay, faFilm, faVideo, faSearch, faLaptopCode, faChalkboardTeacher, faHome, faPhone, faEnvelope, faFileAlt, faFolder, faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import 'element-plus/dist/index.css';
import axios from 'axios';

library.add(faLanguage, faUserAlt, faUsers, faLayerGroup,faBalanceScale, faProjectDiagram, faPencilAlt, faBook, faImage, faRobot, faChartLine, faUserGraduate, faMusic, faPlay, faFilm, faVideo, faSearch, faLaptopCode, faChalkboardTeacher, faHome, faPhone, faEnvelope, faFileAlt, faFolder, faChevronUp, faChevronDown);

export default {
  name: 'App',
  components: {
    ElAside,
    ElMenu,
    ElMenuItem,
    ElMain,
    FontAwesomeIcon,
  },
  data() {
    return {
      activeMenu: '1', // 当前激活的菜单项
      categories: [], // 分类数据初始化为'全部'
      selectedCategory: '全部', // 当前选择的分类
      baseUrl: 'https://mengzi.chat/api/ai/tools', // 后端服务的基础 URL
      isMobile: window.innerWidth < 768, // 判断是否为移动端
      isCategoriesExpanded: false, // 控制分类是否展开
    };
  },
  mounted() {
    this.fetchCategories();
    window.addEventListener('resize', this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    goToHomePage() {
      this.selectedCategory = '全部'; // 重置选中的分类
      document.querySelector('.app-main').scrollTo({ top: 0, behavior: 'smooth' }); // 滚动到页面顶部
      if (this.isMobile) {
        this.isCategoriesExpanded = false; // 收起分类列表
      }
    },
    goToTechDocs() {
      window.location.href = 'https://sr8568rfk7.feishu.cn/docx/GZrhddu5Eo9yLDxMmD2cFDS8nog';
    },
    updateSelectedCategory(category) {
      if (category !== this.selectedCategory) {
        this.selectedCategory = category;
        this.$router.replace({ name: 'HomePage', query: { category } }).catch(() => {});
      }
    },
    getCategoryIcon(category) {
      const iconMap = {
        '文本生成': 'book',
        '图像生成': 'image',
        '视频生成': 'video',
        '搜索引擎': 'search',
        '编程助手': 'laptop-code',
        '视频剪辑': 'film',
        '办公助手': 'chalkboard-teacher',
        '音乐生成': 'music',
        '海报设计': 'layer-group',
        '法律顾问': 'balance-scale', 
        '数据分析': 'chart-line',
        '会议工具': 'users', 
        '思维导图': 'project-diagram',
        '联系我们': 'phone',
        '写作工具': 'pencil-alt',
        '技术文档': 'file-alt',
        '智能体': 'robot',
        '教育辅助': 'school',
        '语言翻译': 'language',
        '数字人': 'user-alt',
      };
      // 如果找不到指定的图标，返回默认图标
      return ['fas', iconMap[category] || 'folder'];
    },
    handleResize() {
      this.isMobile = window.innerWidth < 768;
    },
    async fetchCategories() {
      try {
        const response = await axios.get(`${this.baseUrl}/tools`);
        if (response.status === 200 && response.data) {
          this.categories = [...new Set(response.data.map((tool) => tool.category))];
        } else {
          console.error('获取分类列表失败:', response);
          alert('获取分类列表失败');
        }
      } catch (error) {
        console.error('获取分类列表出错:', error);
        alert('获取分类列表出错');
      }
    },
    toggleCategories() {
      this.isCategoriesExpanded = !this.isCategoriesExpanded;
    },
    handleCategoryClick(category) {
      this.scrollToCategory(category);
      this.isCategoriesExpanded = false; // 点击分类后自动折叠
    },
    scrollToCategory(category) {
      this.selectedCategory = category;
      this.activeMenu = `category-${this.categories.indexOf(category)}`;
      const targetSection = document.querySelector(`#category-${category}`);
      if (targetSection) {
        targetSection.scrollIntoView({ behavior: 'smooth' });
      }
      if (this.isMobile) {
        this.isCategoriesExpanded = false; // 点击分类后自动折叠
      }
    },
    goToAboutPage() {
      this.$router.push({ name: 'AboutPage' });
    },
    scrollToTop() {
      document.querySelector('.app-main').scrollTo({ top: 0, behavior: 'smooth' });
    },
  },
};
</script>

<style scoped>
/* 改进左侧导航栏样式 */
#app {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden; /* 防止整个页面生成滚动条 */
}

.app-body {
  display: flex;
  flex-grow: 1;
  height: 100%;
}

.app-sidebar {
  background-color: #f5f5f5;
  color: #333;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center; /* 使用 flexbox 让内容居中对齐 */
  justify-content: flex-start; /* 保持顶部对齐 */
  height: 100%; /* 让导航栏充满父容器的高度 */
}

.logo-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start; /* 让 logo 保持在顶部对齐 */
  margin-bottom: 30px;
}

.logo {
  width: 60px;
  height: 60px;
  margin-bottom: 10px;
}

.title {
  font-size: 22px;
  font-weight: bold;
  color: #333;
}

/* 工具集菜单项 */
.menu-item {
  font-size: 20px; /* 增大字体 */
  padding: 20px 25px; /* 增大卡片尺寸，使背景看起来更大 */
  margin-bottom: 10px; /* 增加分类项之间的上下间距 */
  display: flex;
  align-items: center;
  justify-content: flex-start; /* 图标和文本左对齐 */
  width: calc(100% - 20px); /* 留出左右的空隙，增大背景效果 */
  border-radius: 10px; /* 让背景边框更圆润 */
  background-color: transparent; /* 默认状态下背景透明 */
}

.menu-icon {
  font-size: 20px; /* 增大图标大小 */
  margin-right: 8px; /* 增加图标与文本之间的间距 */
}

.menu-item span {
  font-size: 18px;
  color: #333;
}

.menu-item:hover {
  background-color: #e6f7ff; /* 鼠标悬停时背景色变化 */
}

/* 移动端和桌面端顶部区域样式 */
.header {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  background-color: #f5f5f5;
  text-align: center;
}

.header-logo-container {
  margin-bottom: 10px;
}

.header-logo {
  width: 80px;
  height: auto;
  margin-bottom: 5px;
}

.mobile-header-description {
  font-size: 12px;
  color: #555;
}

.contact-us-button {
  margin-top: 10px;
  padding: 4px 10px;
  font-size: 10px;
  background-color: #2495ff;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.contact-us-button:hover {
  background-color: #1b74d4;
}

/* 美化全部分类按钮 */
.category-toggle-button {
  margin-top: 10px;
  padding: 6px 12px; /* 调整按钮内边距 */
  font-size: 12px; /* 调整字体大小 */
  background-color: #2495ff; /* 使用推荐的科技色 */
  color: #fff; /* 保持文字颜色为白色 */
  border: none;
  border-radius: 8px; /* 边框圆角 */
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.3s ease;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2); /* 增加阴影效果 */
}

.category-toggle-button:hover {
  background-color: #4fa8fa; /* 鼠标悬停时变深一点的紫色 */
  transform: translateY(-3px); /* 鼠标悬停时的浮动效果 */
}


/* 动态分类折叠面板 */
.category-panel {
  background-color: #f9f9f9;
  padding: 10px;
  border-radius: 10px;
  max-height: 300px; /* 设置最大高度，避免内容过多撑开 */
  overflow-y: auto; /* 内容超出时滚动 */
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px; /* 减少间隙 */
  justify-content: center;
}

/* 分类项样式 */
.category-item {
  display: flex;
  align-items: center;
  padding: 4px 6px;
  background-color: #2495ff; /* 修改为指定的蓝色 */
  color: #fff;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  flex: 0 0 calc(30% - 10px); /* 每行可以容纳三个分类项 */
  margin-bottom: 6px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 11px;
}

.category-item:hover {
  background-color: #1b78cc; /* 鼠标悬停时稍微变深的蓝色 */
}


/* 分类项中的图标和文字 */
.category-item .menu-icon {
  font-size: 12px; /* 调整图标大小 */
  margin-right: 4px; /* 调整图标与文本之间的间距 */
}

.category-item span {
  font-size: 12px; /* 调整文字大小 */
  line-height: 1; /* 确保文字紧凑地排列 */
}


/* 内容区域样式 */
.app-main {
  flex-grow: 1;
  padding: 20px;
  background-color: #f0f0f0;
  overflow: auto;
  height: 100%;
  box-sizing: border-box;
}

.desktop-header {
  text-align: center;
  margin-bottom: 20px;
}

.desktop-header-logo {
  width: 150px;
  height: auto;
}

.desktop-header-description {
  font-size: 16px;
  color: #555;
  margin-top: 10px;
}

/* 一键回到顶部按钮 */
.back-to-top {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  opacity: 0.7;
  transition: opacity 0.3s;
}

.back-to-top:hover {
  opacity: 1;
}

/* 响应式优化 */
@media (max-width: 768px) {
  .app-body {
    flex-direction: column;
  }

  .app-sidebar {
    display: none; /* 移动端隐藏左侧导航栏 */
  }

  .header {
    padding: 8px;
  }

  .app-main {
    padding: 10px;
    height: auto;
  }

  .category-panel {
    transition: max-height 0.3s ease, opacity 0.3s ease;
  }

  .category-panel.expanded {
    display: flex;
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  .app-body {
    display: flex;
    flex-direction: row;
  }

  .app-main {
    padding: 20px;
    height: 100%;
  }

  .menu-item {
    font-size: 16px; /* 平板上稍微减小字体 */
  }
}

@media (max-width: 426px) {
  .header-logo {
    width: 60px;
  }

  .mobile-header-description {
    font-size: 10px;
  }

  .button-group {
    display: flex;
    gap: 30px !important; /* 强制增加按钮之间的间距 */
    justify-content: center; /* 居中按钮 */
  }
}

/* 分类折叠动画效果 */
.slide-fade-enter-active, .slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter, .slide-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}
</style>